import React from 'react';

import { IS_DEVELOPMENT, IS_LOCAL, isDefined, silenceError } from '@nfctron/nexus-core';
import { useIsMounted } from '@nfctron/nexus-react';

import NextErrorComponent from 'next/error';
import { useRouter } from 'next/router';

import { getDnsHostConfig } from '@root/config/dns.config';

import { wrapStaticPropsWithI18n } from '@root/lib/modules/next/next.module';

/**
 * 404 Not Found page component view
 * @constructor
 */
const NotFoundPage = () => {
	const isMounted = useIsMounted();
	const router = useRouter();
	const redirectTo = silenceError(() => {
		/** no redirects on local or development */
		if (IS_LOCAL || IS_DEVELOPMENT) return null;
		/** get active host from the list if matching any */
		const wd = typeof window !== 'undefined' ? window : null;
		const dnsHost = getDnsHostConfig(wd?.location.hostname ?? 'tickets.nfctron.cz');
		if (isDefined(dnsHost)) return dnsHost.urls.getHomeUrl({ locale: router.locale }).href;
		return new URL('https://www.nfctron.com').href;
	}, null);

	/** redirect all production 404 pages to the legacy Pass website / org integrator main host index */
	React.useEffect(() => {
		if (isDefined(redirectTo)) window.location.assign(redirectTo);
	});

	if (!isMounted || isDefined(redirectTo)) return null;

	return <NextErrorComponent statusCode={404} />;
};

/** page static props */
export const getStaticProps = wrapStaticPropsWithI18n(
	async ({}) => {
		return {
			props: {},
		};
	},
	{
		pathname: '/404',
	},
);

export default NotFoundPage;
